
define('template!mailsListLabelsFilterView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="labels-filter-container">\n  <div class="labels-filter-header">\n    <span class="filter-by-label-text">Filter by labels:</span>\n  </div>\n  <div class="labels-actions">\n    <button class="btn btn-xs btn-primary add-label">Add Label</button>\n    <button class="btn btn-xs btn-default clear-filter">Clear All</button>\n  </div>\n  <div class="selected-labels-container">\n    <!-- Selected labels will be displayed here -->\n  </div>\n</div>';

}
return __p
};});

